import { dateHeader, formatCellDate } from './timeModeCell';

export const makeManageInventoryColumn = (handleViewSummary: (data: any) => void) => {
  const col = [
    {
      header: 'Summary',
      sortable: false,
      enableColumnFilter: false,
      size: 150,
      cell: ({ row }) => {
        return (
          <div style={{ cursor: 'pointer' }} onClick={() => handleViewSummary(row.original)}>
            <span style={{ textDecoration: 'underline' }}>Detail summary</span>
          </div>
        );
      },
    },
    {
      header: 'Created By',
      accessorKey: 'createdUserName',
      sortable: false,
      enableColumnFilter: false,
      size: 190,
    },
    {
      header: 'Newly Found Devices',
      accessorKey: 'newlyFoundDevicesCount',
      size: 150,
    },
    {
      header: 'Created Devices',
      accessorKey: 'createdDevicesCount',
      size: 120,
    },
    {
      header: 'Total Found Devices',
      accessorKey: 'totalFoundDevicesCount',
      size: 110,
    },
    {
      header: dateHeader('Created'),
      accessorKey: 'createdDateTime',
      enableColumnFilter: true,
      size: 110,
      cell: ({ row, table }) => formatCellDate(table, row.original.createdDateTime),
    },
  ] as Array<any>;

  return col;
};
